import { defineAction } from '~/prix'
import residenceByCommunityReportAction from './generalResidenceByCommunityReport.action.json' with { type: 'json' }
import { z } from 'zod'
import { reportFormatSchema } from '~/utils/server/report'

const residenceByCommunityReportDefinition = defineAction({
  ...residenceByCommunityReportAction,

  input: z.object({
    type: z.enum(['publicSafety', 'publicHealth']),
    communityId: z.string().nullish(),
    hasResidenceCitizensDetails: z.enum(['true', 'false']).nullish().default('false'), // Pois recebo via URL/string/query param
    format: reportFormatSchema,
  }),
  output: z.any(),
})

export default residenceByCommunityReportDefinition
